import { jwtDecode } from 'jwt-decode';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import Group from '../../images/login/Group.png';
import EmailImg from '../../images/SideBar/Email';
import Eyes from '../../images/SideBar/Eyes';
import LockImg from '../../images/SideBar/Lock';
import { apiPaths } from '../../service/apiPaths';
import ApiService from '../../service/ApiService';
import Loader from '../Loader';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();

  // Function to handle login
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Login attempt with username:", username);
    setLoading(true);
    try {
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.Login,
        data: { email: username, password },
      });

      console.log("Login response received:", response);

      const { token, refreshToken: receivedRefreshToken, user } = response;
      if (token) {
        const decodedToken: any = jwtDecode(token);
        const role: any = decodedToken.role;
        const userId: any = decodedToken.userId;

        if (user.subRole) {
          localStorage.setItem("subRole", user.subRole);
        }
        if (userId) {
          console.log("user.userId", userId);
          localStorage.setItem("userId", userId);
        }
        // Store user email for Gmail calendar integration
        if (user.email) {
          localStorage.setItem("userEmail", user.email);
        } else {
          // If user.email is not available, use the login username
          localStorage.setItem("userEmail", username);
        }
        // Also store the login username as fallback
        localStorage.setItem("loginUsername", username);
        localStorage.setItem("role", role);
        localStorage.setItem("accessToken", token);

        // Attempt to link user to Jibble in the background
        const linkEmail = (user?.userEmail || user?.email || username || localStorage.getItem("userEmail") || "").trim();
        if (linkEmail) {
          console.log("Attempting Jibble link with email:", linkEmail);
          ApiService({
            method: "POST",
            endpoint: apiPaths.jibbleLink,
            data: { email: linkEmail },
          })
            .then(() => {
              localStorage.setItem("jibbleLinked", "true");
              console.log("Jibble link success");
            })
            .catch((linkErr) => {
              console.warn("Jibble link failed", linkErr);
              localStorage.removeItem("jibbleLinked");
            });
        } else {
          console.warn("Jibble link skipped: no email available");
        }

        // Fetch sequences without reload
        await fetchSequences();

        console.log("Login successful, navigating to home page...");
        onLogin();
        navigate("/");
      } else {
        setError("Invalid username or password");
        console.error("Login failed: Invalid username or password");
      }
    } catch (error) {
      setError("Error occurred during login");
      console.error("Error logging in:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSequences = async () => {
    try {
      console.log("Fetching sequences...");
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.searchEmailerCampaigns,
      });
      localStorage.setItem(
        "sequences",
        JSON.stringify(response.emailer_campaigns || [])
      );
      console.log("Sequences fetched successfully");
      window.location.reload();
    } catch (error) {
      console.error("Failed to fetch sequences:", error);
      toast.error("Failed to fetch sequences");
    }
  };

  return (
    <div className="bg-gradient-to-tr from-blue-300 via-gray-300 to-blue-300">
      {loading && <Loader />}
      <div className="min-h-screen  flex items-center justify-center">
        <div className=" p-6 rounded-xl bg-white/50 backdrop-blur-lg  border mx-auto flex items-center justify-center ">
          <div>
            <h1 className="text-2xl font-bold text-start text-fontBlack">
              Login to your account
            </h1>
            <form onSubmit={handleLogin} className="mt-[5%]">
              <div className="mb-4">
                <div className="mt-1 bg-white flex items-center w-[404px] h-[56px] px-3 py-2 border border-border rounded-lg shadow-sm">
                  <EmailImg />
                  <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="ml-2 text-fontColor  text-[18px] w-[398px] h-[50px] focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Enter your email"
                  />
                </div>
              </div>
              <div className="mb-4  relative">
                <div className="mt-1 bg-white flex items-center w-[404px] h-[56px] px-3 py-2 border border-border rounded-lg shadow-sm">
                  <LockImg />
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="ml-3 text-fontColor  text-[18px] w-[404px] h-[50px] focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Password"
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <Eyes />
                  </button>
                </div>
              </div>
              <p className="text-red-500 -mt-3">{error}</p>
              <div className="mt-[20%]">
                <button
                  type="submit"
                  className="w-full py-2 px-4 h-[56px] border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-loginBg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Log in
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;